import Txt from './Txt'

export default Txt
// eslint-disable-next-line import/export
export * from './Txt'
